// Hooks
import { useContext } from 'react'
import { useFlag } from '@sketch/modules-common'

// Components
import { ModalContext } from '@sketch/components'
import ShareSettingsModal, {
  ShareMinimalForSettingsModal,
} from 'modules/shares/modals/ShareSettingsModal'
import SharingModal from 'modules/shares/modals/SharingModal'

export const useSharingModal = (share: ShareMinimalForSettingsModal) => {
  const { showModal } = useContext(ModalContext)
  const isNewSharingOn = useFlag('new-sharing')

  const openShareSettingsModal = (options?: {
    closeOnRouteChange: boolean
  }) => {
    if (!isNewSharingOn) {
      return showModal(ShareSettingsModal, { share }, options)
    }

    return showModal(SharingModal, {
      identifier: share.identifier,
      name: share.name,
    })
  }

  return { openShareSettingsModal }
}
